// OLD COLORS
// 14804A // opened
// 990407 // reopen
// 007481 // solved

import {
  alarWarningLineIcon,
  arrowDownDoubleIcon,
  arrowUpDoubleIcon,
  equalLineIcon,
} from "@src/assets/images/svgs";

// EB5757 // escalated
export const TicketConstants = {
  STATUSES: {
    all: { KEY: "all", LABEL: "All", COLOR: "", count: 0 },
    opened: { KEY: "opened", LABEL: "Opened", COLOR: "#F17B2C", count: 0 },
    reopened: {
      KEY: "reopened",
      LABEL: "Reopened",
      COLOR: "#AF1D38",
      count: 0,
    },
    solved: { KEY: "solved", LABEL: "Solved", COLOR: "#38C793", count: 0 },
    closed: { KEY: "closed", LABEL: "Closed", COLOR: "#176448", count: 0 },
    overdue: { KEY: "overdue", LABEL: "Overdue", COLOR: "#F2AE40", count: 0 },
    escalate: {
      KEY: "escalate",
      LABEL: "Escalated",
      COLOR: "#DF1C41",
      count: 0,
    },
    escalated: {
      KEY: "escalated",
      LABEL: "Escalated",
      COLOR: "#DF1C41",
      count: 0,
    },
    bookmark: {
      KEY: "bookmark",
      LABEL: "Bookmarked",
      COLOR: "#FFD700",
      count: 0,
    },
  },
  PRIORITIES: {
    high: {
      KEY: "high",
      LABEL: "High",
      COLOR: "#AF1D38",
      ICON: arrowUpDoubleIcon,
    },
    medium: {
      KEY: "medium",
      LABEL: "Medium",
      COLOR: "#C2540A",
      ICON: equalLineIcon,
    },
    low: {
      KEY: "low",
      LABEL: "Low",
      COLOR: "#2D9F75",
      ICON: arrowDownDoubleIcon,
    },
    critical: {
      KEY: "critical",
      LABEL: "Critical",
      COLOR: "#DF1C41",
      ICON: alarWarningLineIcon,
    },
    blank: { KEY: "", LABEL: "", COLOR: "" },
  },
  BLANKS: {
    PRIORITY: { KEY: "", LABEL: "", COLOR: "" },
  },
  COMMENT_TYPE_LABELS: {
  dependency_added: "Dependency Added",
  reopened: "Reopened",
  closed: "Closed",
  solved: "Solved",
  "Returned to requester": "Returned to Requester",
 }
};

export const ModulesName = {
  PERMISSIONS: "permissions",
  COMMENTS: "comments",
  DYNAMIC_FIELDS: "dynamic_fields",
  ESCALATION: "escalation",
  OPERATION_CENTER: "operation_center",
  TEAMS: "teams",
  USERS: "users",
  REQUEST_LIST_USER: "request_list_user",
  RESTORE_LIST_USER: "restore_list_user",
  TRANSLATIONS: "translations",
};

export const dateFormats = {
  "ddd MMM Do YYYY, hh:mm A": "ddd MMM Do YYYY, hh:mm A",
  "DD MMM YYYY": "DD MMM YYYY",
  "YYYY-MM-DD": "YYYY-MM-DD",
  "DD/MM/YYYY": "DD/MM/YYYY",
  "MM/DD/YYYY": "MM/DD/YYYY",
  "MMMM D, YYYY": "MMMM D, YYYY",
  "D MMMM YYYY": "D MMMM YYYY",
  "ddd, DD MMM YYYY": "ddd, DD MMM YYYY",
  "dddd, MMMM D, YYYY": "dddd, MMMM D, YYYY",
  "YYYY.MM.DD": "YYYY.MM.DD",
  "DD-MMM-YYYY": "DD-MMM-YYYY",
  "MMM D, YYYY hh:mm A": "MMM D, YYYY hh:mm A",
};

export const legalInfoInitialContent = () => {
  const project = process.env.REACT_APP_PROJECT;
  switch (project) {
    case "nhcc":
      return `Ascend Solutions Limited (“Company”) owns and operates
         this product “Enovii LiveAgent”(Product), licensed and white-labeled
          to the Ministry of Health – National Health Command Centre (“MOH-NHCC”)
           under the brand NHCC Ticketing. Access to and use of this product,
                Enovii LiveAgent, or NHCC Ticketing are governed by these Terms
                of Use`;
    case "CC-MOHU":
      return `Ascend Solutions Limited (“Company”) owns and operates
         this product “Enovii LiveAgent”(Product), licensed and white-labeled
          to the Ministry of Hajj and Umrah (MOHU) under the brand Mohu Ticketing. Access to and use of this product,
                Enovii LiveAgent, or Mohu Ticketing are governed by these Terms
                of Use`;
    case "hhc-nmr":
      return `Ascend Solutions Limited (“Company”) owns and operates
         this product “Enovii LiveAgent”(Product), licensed and white-labeled
          to the Health Holding Company - Navigation and Monitring Response (HHC - NMR)
           under the brand NMR Ticketing. Access to and use of this product,
                Enovii LiveAgent, or NMR Ticketing are governed by these Terms
                of Use`;
    case "haram":
      return `Ascend Solutions Limited (“Company”) owns and operates
         this product “Enovii LiveAgent”(Product), licensed and white-labeled
          to the Haramain (Haramain) under the brand Haram Ticketing. Access to and use of this product,
                Enovii LiveAgent, or Haram Ticketing are governed by these Terms
                of Use`;
  }
};
